import { useEffect, useState } from 'react';
import { Api } from 'lavva.exalushome';
import { IUpdatesService } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService';
import { UpdatesService } from 'lavva.exalushome/build/js/Services/Updates/UpdatesService';
import { useInstallationContext } from '../../../../../context/installation';
import { diffHours } from '../../../../../utils/helpers';
import { useExalusContext } from '../../../context';
import * as exalusStorage from '../../../storage';

export const useUpdateDevices = () => {
  const [updateDevicesOpen, setUpdateDevicesOpen] = useState<boolean>(false);
  const { selectedInstallationId } = useInstallationContext();
  const { synchronized, connected } = useExalusContext();

  const handleSaveDevicesMemoryForInstallationId = () => {
    if (selectedInstallationId) {
      let updateDevicesMemory = exalusStorage.getItem('updateDevicesMemory');

      if (updateDevicesMemory) {
        if (selectedInstallationId in updateDevicesMemory) {
          updateDevicesMemory[selectedInstallationId] = new Date();
        } else updateDevicesMemory = { ...updateDevicesMemory, [selectedInstallationId]: new Date() };
      } else updateDevicesMemory = { [selectedInstallationId]: new Date() };

      exalusStorage.setItem('updateDevicesMemory', updateDevicesMemory);
    }
  };

  const checkDevicesUpdateAvailability = async () => {
    const updateService = Api.Get<IUpdatesService>(UpdatesService.ServiceName);
    const result = await updateService.CheckDevicesUpdatesAvailabilityAsync();

    handleSaveDevicesMemoryForInstallationId();
    if (result.length) setUpdateDevicesOpen(true);
  };

  useEffect(() => {
    if (!selectedInstallationId || !synchronized || !connected) return;
    const updateDevicesMemory = exalusStorage.getItem('updateDevicesMemory');

    if (updateDevicesMemory) {
      if (selectedInstallationId in updateDevicesMemory) {
        if (diffHours(new Date(updateDevicesMemory[selectedInstallationId]), 24)) checkDevicesUpdateAvailability();
      } else checkDevicesUpdateAvailability();
    } else checkDevicesUpdateAvailability();
  }, [selectedInstallationId, synchronized, connected]);

  return {
    updateDevicesOpen,
    setUpdateDevicesOpen,
    handleSaveDevicesMemoryForInstallationId,
  };
};
